export const number = ({
  min = 0,
  max = 1000,
  divisibleBy = 1,
}: {
  min?: number;
  max?: number;
  /**
   * Return an integer that can be divided by this number.
   */
  divisibleBy?: number;
}) => {
  const num = Math.round(Math.random() * (max - min) + min);
  const remainder = num % divisibleBy;

  return num - remainder;
};
